import { FunctionComponent, useState } from 'react';
import { BoardingTabId } from './Tabs/BoardingTabs';
import { BoardingNavbar } from './Tabs/BoardingNavbar';
import BoardingServices from './Services/BoardingServices';
import BoardingRates from './Rates/BoardingRates';
import BoardingRateRules from './RateRules/BoardingRateRules';
import styles from './BoardingComponent.module.scss';

const BoardingComponent: FunctionComponent = () => {
    const [selectedTab, setSelectedTab] = useState<BoardingTabId>('services');

    const renderTabContent = () => {
        switch (selectedTab) {
            case 'services':
                return <BoardingServices />;
            case 'rates':
                return <BoardingRates />;
            case 'rate_rules':
                return <BoardingRateRules />;
            default:
                return <BoardingServices />;
        }
    };

    return (
        <div className={styles.container}>
            <BoardingNavbar
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
            />
            <div className={styles.contentWrapper}>{renderTabContent()}</div>
        </div>
    );
};

export default BoardingComponent;
